import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

function EdgeText(props) {
  const { x, y, label } = props;

  const [textBox, setTextBox] = useState({ width: 0, height: 0 });

  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      const rect = textRef.current.getBoundingClientRect();
      setTextBox({
        width: rect.width,
        height: rect.height,
      });
    }
  }, [label]);

  const padding = [2, 4];
  if (!label) {
    return null;
  }

  const bgWidth = textBox.width + padding[1] * 3;
  const bgHeight = textBox.height + padding[0] * 3;

  return (
    <g
      visibility={!textBox.width ? 'hidden' : undefined}
      style={{ transform: `translate(${x - textBox.width / 2}px, ${y - textBox.height / 2}px)` }}
    >
      <rect
        className="icp-workflow-edge-text-bg"
        width={bgWidth}
        height={bgHeight}
        x={-padding[1] * 1.5}
        y={-padding[0]}
        rx={8}
        ry={8}
      />
      <text
        className="icp-workflow-edge-text"
        y={textBox.height / 2}
        dy={bgHeight / 2 - textBox.height / 2 + 2}
        ref={textRef}
      >
        {label}
      </text>
    </g>
  );
}

EdgeText.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  label: PropTypes.string,
};

export default EdgeText;
